/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { GetDocumentQuotaQueryResponse } from '../../types/GetDocumentQuota'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getDocumentQuota } from '../../clients/getDocumentQuota'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getDocumentQuotaQueryKey = () =>
  [{ url: '/api/v1/documents/quota/' }] as const

export type GetDocumentQuotaQueryKey = ReturnType<
  typeof getDocumentQuotaQueryKey
>

export function getDocumentQuotaQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getDocumentQuotaQueryKey()
  return queryOptions<
    GetDocumentQuotaQueryResponse,
    ResponseErrorConfig<Error>,
    GetDocumentQuotaQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getDocumentQuota({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @description Get storage quota information for user's company.
 * Returns:
 * DocumentContainerQuotaSerializer with max_size, current_usage,
 * remaining_space, and usage_percentage
 * @summary Get storage quota for the current company
 * {@link /api/v1/documents/quota/}
 */
export function useGetDocumentQuota<
  TData = GetDocumentQuotaQueryResponse,
  TQueryData = GetDocumentQuotaQueryResponse,
  TQueryKey extends QueryKey = GetDocumentQuotaQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetDocumentQuotaQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getDocumentQuotaQueryKey()

  const query = useQuery(
    {
      ...getDocumentQuotaQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
